var chunkToChildrenMap = {
	"1480": [
		697,
		4135,
		4420
	],
	"3664": [
		8754,
		2872,
		1480
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};